import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmEntry = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 10, fill: "#10B981", fillOpacity: 0.1 }), /* @__PURE__ */ React.createElement("path", { d: "M7.86339 12.5826L5.08339 9.80263L4.13672 10.7426L7.86339 14.4693L15.8634 6.4693L14.9234 5.5293L7.86339 12.5826Z", fill: "#10B981" }));
const ForwardRef = forwardRef(SvgConfirmEntry);
export { ForwardRef as ReactComponent };
